import { createSelectionListViewComponent } from 'factories/SelectionListView'
import { getSessionItem, updateSessionItem } from 'helpers/sessionStorage'
import { getStorageKey } from '.'
import { AUTH_SESSION_KEY } from 'options/auth'

export default createSelectionListViewComponent({
  pageTitle: () => getSessionItem(AUTH_SESSION_KEY).current.customer.tagSettings.tag2,
  getItemSize: () => 45,
  allowSearch: () => true,
  getIdField: () => 'displayName',
  getValue: () => getSessionItem(getStorageKey(), {}).item?.operatorDisplayName || '',
  getOnChange: (self) => (each) =>
    updateSessionItem(getStorageKey(), {}, (draft) => {
      draft.item.operatorId = each.id
      draft.item.operatorName = each.name || '*'
      draft.item.operatorNumber = each.number
      draft.item.operatorBarcode = each.barcode
      draft.item.operatorDisplayName = each.displayName
    }),
})()
